import { IConstraintMinMaxRigsPerAreaDetail } from '../../interfaces/iconstraint-min-max-rigs-per-area-detail';
import { Area } from '../area';
import { ConstraintMinMaxRigsPerArea } from '../constraint-min-max-rigs-per-area';

export class ConstraintMinMaxRigsPerAreaDetailBase {
  ConstraintMinMaxRigsPerAreaDetailId: number;
  ConstraintMinMaxRigsPerAreaId: number;
  AreaId: number;
  MinimumNumber: number | null;
  MaximumNumber: number | null;
  EffectiveStartDate: Date | null;
  EffectiveFinishDate: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  ConstraintMinMaxRigsPerArea?: ConstraintMinMaxRigsPerArea;

  constructor(item?: IConstraintMinMaxRigsPerAreaDetail) {
    if (item) {

      this.ConstraintMinMaxRigsPerAreaDetailId = item.ConstraintMinMaxRigsPerAreaDetailId;
      this.ConstraintMinMaxRigsPerAreaId = item.ConstraintMinMaxRigsPerAreaId;
      this.AreaId = item.AreaId;
      this.MinimumNumber = item.MinimumNumber;
      this.MaximumNumber = item.MaximumNumber;
      this.EffectiveStartDate = item.EffectiveStartDate ? new Date(item.EffectiveStartDate) : null;
      this.EffectiveFinishDate = item.EffectiveFinishDate ? new Date(item.EffectiveFinishDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.ConstraintMinMaxRigsPerArea = new ConstraintMinMaxRigsPerArea(item.ConstraintMinMaxRigsPerArea);
    }
  }
}